import { useEffect } from 'react';
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';
import { useFootPrintTrackingMutation } from 'containers/Globals/queries';

// this is flag to disable fingerprint call to the fingerprint server
const isFingerPrintEnabled = process.env.IS_FINGER_PRINT_TRACKING_ENABLED;

export const FootPrintTracking = ({ children, data }) => {
  const { data: visitorData } = useVisitorData(
    { extendedResult: true },
    { immediate: isFingerPrintEnabled === 'true' },
  );
  const footPrintTrackingMutation = useFootPrintTrackingMutation();
  useEffect(() => {
    if (visitorData?.visitorId) {
      const payload = {
        visitorId: visitorData.visitorId,
        ...data,
        metaData: { ...visitorData, ...data?.metaData },
      };
      footPrintTrackingMutation.mutate(payload);
    }
  }, [visitorData?.visitorId, data?.pageSubType, data?.pageType, data?.metaData?.entityId, data?.section]);

  return children;
};

const useFootPrintTracker = () => {
  const { data: visitorData } = useVisitorData(
    { extendedResult: true },
    { immediate: isFingerPrintEnabled === 'true' },
  );
  const footPrintTrackingMutation = useFootPrintTrackingMutation();
  const trackFingerPrint = data => {
    if (visitorData?.visitorId) {
      const payload = {
        visitorId: visitorData.visitorId,
        ...data,
        metaData: { ...visitorData, ...data?.metaData },
      };
      footPrintTrackingMutation.mutate(payload);
    }
  };
  return trackFingerPrint;
};

export default useFootPrintTracker;
